import { ResourceLevelingPreferenceBase } from './base/resource-leveling-preference-base';

export class ResourceLevelingPreference extends ResourceLevelingPreferenceBase { }